import type { IContractRequirementItem, IScheduleSummary } from '@/store/types';

const parseSchedulesToString = (item: IContractRequirementItem): string =>
  item.contractRequirementScheduleSummary.map(item => item.scheduleName).join(', ');

const getSchedulesTranslationSuffix = (
  item: IContractRequirementItem,
  contractSchedules: IScheduleSummary[] | null | undefined,
): 'mustWorkAll' | 'mustWork' =>
  contractSchedules?.length === item.contractRequirementScheduleSummary.length ? 'mustWorkAll' : 'mustWork';

export { parseSchedulesToString, getSchedulesTranslationSuffix };
